import { get_token } from "@/router";

import Sidebar from '@/components/Sidebar/SidebarView.vue';
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import Swal from 'sweetalert2';
import { client_domain } from "@/main.js";

export default {

  components: {
    Sidebar,
    HomeNavBar
  },
  inject: ['client_features'],

  mounted() {
    this.get_dashboard();

    if (client_domain.includes('dwypd') || client_domain.includes('soulcity') || client_domain.includes('nsp')) {
        this.dwypd_domain = true;
      }
  },

  data() {
    var data = {
      total_users: 0,
      total_portals: 0,
      total_reports: 0,
      total_memberships: 0,
      total_events:0,
      total_business_profiles: 0,
      total_campaigns: 0,
      dwypd_domain:false,
    }

    return data;
  },

  methods: {

    toggleSidebar() {
      this.$refs.sidebar.toggle();
    },

    open_campaign_dashboard() {
      this.$router.push({ name: 'donation_campaigns_dashboard' });
    },

    go_to_dashboard_card(path) {
      if (!path || path === '#') {
        return;
      }

      this.$router.push(path);
    },

    get_dashboard() {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/dashboard/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${get_token()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {

          var response_data = response.data;

          this.total_users = response_data.total_users || 0;
          this.total_portals = response_data.total_portals || 0;
          this.total_reports = response_data.total_reports || 0;
          this.total_memberships = response_data.total_memberships || 0;
          this.total_events = response_data.total_events || 0;
          this.total_business_profiles = response_data.total_business_profiles || 0;
          this.total_campaigns = response_data.total_campaigns || 0;
        },
        error:(response)=>{
          this.$router.push("/");
          if (response.status === 403) {
            Swal.fire({
              icon: "error",
              title: "Access Denied",
              text: "You are not authorized to access dashboard.",
              showConfirmButton: false,
              timer: 3000,
              position: 'bottom-end',
              toast: true
            });}
        },
        complete: () => {
          this.isLoading = false;
          $('#loader').hide();
        }
      });

    },

  }

}
